
import { ITagGroup } from '@/src/interfaces/tag-manager';

import { useClicksterStore } from '..';
import isEqual from 'lodash/isEqual';
import keyBy from 'lodash/keyBy';
import { TagsStore } from './slice';
import { ITag } from "@clickster/constant-definitions/dist-esm/entities/tag/types";

/* TAGS */
const setStateTags = ({ tags, tagsGroups, tagsById }: TagsStore) => {
    useClicksterStore.setState({
        tags,
        tagsGroups,
        tagsById
    });
};

const setNewTag = (tag: ITag) => {
    useClicksterStore.setState({
        tags: [...useClicksterStore.getState().tags, tag]
    });
};

const setAvailableTags = (tags: ITag[]) => {
    useClicksterStore.setState((state) => {
        return {
            ...state,
            tags
        }
    });
};

const replaceAvailableTag = (tag: ITag) => {
    useClicksterStore.setState((state) => {
        return {
            tags: state.tags.map(t => t._id === tag._id ? tag : t)
        }
    });
};

const deleteTag = (tagId: string) => {
    useClicksterStore.setState((state) => {
        const filteredTags = state.tags.filter(t => t._id !== tagId);
        return {
            tags: filteredTags
        };
    });

};

/* TAG GROUPS */
const setTagGroups = (keyStorage: string, tagGroups: ITagGroup[]) => {
    useClicksterStore.setState({
        tagsGroups: {
            ...useClicksterStore.getState().tagsGroups,
            [keyStorage]: {
                groups: tagGroups,
                mainGroupOperator: 'OR'
            }
        }
    });
};

const setToggleTagGroupOperator = (keyStorage: string, tagGroupId: string) => {
    console.log('[GlobalTagSystem][TOGGLE_TAG_GROUP_OPERATOR]', {
        keyStorage,
        tagGroupId
    });
    useClicksterStore.setState((state) => {
        return {
            tagsGroups: {
                ...state.tagsGroups,
                [keyStorage]: {
                    ...state.tagsGroups[keyStorage],
                    groups: state.tagsGroups[keyStorage].groups.map(group =>
                        group.id === tagGroupId ? { ...group, operator: group.operator === 'OR' ? 'AND' : 'OR' } : group
                    )
                }
            }
        }
    });
};

const setToggleMainGroupOperator = (keyStorage: string) => {
    useClicksterStore.setState((state) => {
        return {
            tagsGroups: {
                ...state.tagsGroups,
                [keyStorage]: {
                    ...state.tagsGroups[keyStorage],
                    mainGroupOperator: state.tagsGroups[keyStorage].mainGroupOperator === 'OR' ? 'AND' : 'OR'
                }
            }
        }
    });
};

const moveTagToGroup = (keyStorage: string, tagId: string, fromGroupId: string | null, toGroupId: string) => {
    let currentTagGroups = useClicksterStore.getState().tagsGroups[keyStorage];

    if (fromGroupId) {
        currentTagGroups = {
            ...currentTagGroups,
            groups: currentTagGroups.groups.map(group =>
                group.id === fromGroupId ? { ...group, tagIds: group.tagIds.filter(id => id !== tagId) } : group
            )
        }
    }

    currentTagGroups = {
        ...currentTagGroups,
        groups: currentTagGroups.groups.map(group =>
            group.id === toGroupId ? { ...group, tagIds: [...group.tagIds, tagId] } : group
        )
    }

    useClicksterStore.setState({
        tagsGroups: {
            ...useClicksterStore.getState().tagsGroups,
            [keyStorage]: {
                ...currentTagGroups,
                groups: currentTagGroups.groups
            }
        }
    });

};


export const tagStoreSubscribe = (tags: ITag[], prevTags: ITag[]) => {
    if (!isEqual(tags, prevTags)) {
        const tagsById = keyBy(tags, '_id');
        useClicksterStore.setState({
            tagsById: tagsById as any
        });
    }
}


export const TagsManagerActions = {
    tags: {
        setStateTags,
        setNewTag,
        setAvailableTags,
        replaceAvailableTag,
        tagStoreSubscribe,
        deleteTag
    },
    tagGroups: {
        setTagGroups,
        setToggleTagGroupOperator,
        moveTagToGroup,
        setToggleMainGroupOperator
    }
};


